import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IUserAccount } from '../../../services/user-accounts/model/user-account.interface';
import { TranslateModule } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
import { SvgIconComponent } from '@ui-lib/components';
import { ActivityWidgetComponent } from '../activity-widget/activity-widget.component';

@Component({
  selector: 'rrp-user-account-item',
  templateUrl: './user-account-item.component.html',
  styleUrls: ['./user-account-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [TranslateModule, DecimalPipe, ActivityWidgetComponent, SvgIconComponent],
})
export class UserAccountItemComponent {
  @Input({ required: true }) public account!: IUserAccount;

  @Input() public title = '';

  @Input() public isActive = false;
}
